var React = require('react');

function QuoteAttention (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M81.7508 71.9186L42.4029 16.557C42.1285 16.1707 41.6588 15.959 41.1891 16.0066C40.7142 16.0543 40.3078 16.3559 40.1178 16.7952L13.1084 79.153C12.9237 79.587 12.9764 80.0845 13.2561 80.4602C13.5042 80.8042 13.9 81 14.3222 81C14.3697 81 14.4119 81 14.4594 80.9947L80.8167 73.9984C81.2811 73.9508 81.6874 73.6544 81.8827 73.2258C82.078 72.7971 82.0252 72.2996 81.756 71.9133L81.7508 71.9186ZM44.9941 39.8585L46.6564 55.7086L44.0336 55.9838L42.3712 40.1337L44.9941 39.8585ZM46.572 67.3567C44.8094 67.542 43.2262 66.2613 43.0415 64.4884C42.8568 62.7208 44.1339 61.1331 45.9018 60.9479C47.6644 60.7627 49.2476 62.0434 49.4323 63.8163C49.617 65.5839 48.3399 67.1715 46.572 67.3567Z","fill":"#0000FF"}));
}

QuoteAttention.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = QuoteAttention;

QuoteAttention.default = QuoteAttention;
